var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoaching = function SvgCoaching(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#coaching_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 26a6 6 0 1 0 0-12 6 6 0 0 0 0 12M2.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M31.9 6.5c.187.474.087 1.012-.366 1.25l-9.738 4.927a11.925 11.925 0 0 1-.076 13.87 12 12 0 0 1-5.874 4.329 12.03 12.03 0 0 1-7.305.129 12 12 0 0 1-6.023-4.12 11.92 11.92 0 0 1-1.423-12.317 2.5 2.5 0 0 0 3.024-3.973.05.05 0 0 0-.017-.036A12 12 0 0 1 7.618 8.43L27.988.099c.519-.207 1.106-.054 1.309.463zM16.243 24.243a6 6 0 1 0-8.485-8.486 6 6 0 0 0 8.485 8.486",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coaching_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCoaching;